export const ACCESS_TOKEN_STORAGE_KEY = 'access_token';
export const ACCESS_REFRESH_TOKEN_STORAGE_KEY = 'refresh_token';
export const USER_INFO_STORAGE_KEY = 'user_info';